/**
 * DaGi Hair — enhanced scroll animations via Motion (motion.dev)
 * Loaded when Theme settings → Animations → DaGi scroll animations = Enhanced
 */
import { animate, inView, stagger } from '//dagi-hair.com/cdn/shop/t/13/assets/motion.bundle.js?v=151583957113388358551781714641';

if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('.dagi-reveal, .dagi-reveal-item').forEach((el) => {
    el.classList.add('is-visible');
  });
} else {
  const isExcluded = (el) => el?.closest('[data-dagi-reveal="off"]') != null;

  const revealElement = (el) => {
    if (isExcluded(el) || el.classList.contains('is-visible')) return;
    el.classList.add('is-visible');
    animate(
      el,
      { opacity: [0, 1], y: [24, 0] },
      { duration: 0.65, easing: [0.22, 1, 0.36, 1] }
    );
  };

  document.querySelectorAll('.dagi-reveal').forEach((el) => {
    if (isExcluded(el)) return;
    inView(el, () => revealElement(el), { margin: '0px 0px -8% 0px' });
  });

  document.querySelectorAll('.dagi-reveal-group').forEach((group) => {
    if (isExcluded(group)) return;

    inView(
      group,
      () => {
        const items = group.querySelectorAll('.dagi-reveal-item');
        if (!items.length) {
          revealElement(group);
          return;
        }

        items.forEach((item) => item.classList.add('is-visible'));
        animate(
          items,
          { opacity: [0, 1], y: [24, 0] },
          {
            duration: 0.6,
            delay: stagger(0.08),
            easing: [0.22, 1, 0.36, 1],
          }
        );
      },
      { margin: '0px 0px -8% 0px' }
    );
  });
}
